import { AppRoute } from '@app/core/routing/AppRoute';
import { DefaultStationRedirect } from '@app/core/routing/DefaultStationRedirect';
import { Redirect, Switch } from 'react-router-dom';
import { AodRouter } from '../modules/aod/routing/AodRouter';
import { ReportDefinitionListPage } from '../modules/reports/definitions/list/ReportDefinitionListPage';
import { ReportDefinitionDefaultEditorPage } from '../modules/reports/definitions/update/ReportDefinitionDefaultEditorPage';
import { ReportDefinitionEditorPage } from '../modules/reports/definitions/update/ReportDefinitionEditorPage';
import { AuditAudiosPageAdapter } from '../screens/audios-list/AuditAudiosPageAdapter';
import { AuditConfigPage } from '../screens/audit-config/AuditConfigPage';
import { AuditUploadPageAdapter } from '../screens/files-upload/AuditUploadPageAdapter';
import { GipAlternativeReportPreviewPage } from '../screens/global-reports/gip/gip-alt-report/preview/GipAlternativeReportPreviewPage';
import { GipReportPreviewPage } from '../screens/global-reports/gip/gip-report/preview/GipReportPreviewPage';
import { GlobalSchedulesNoMatchesReportPage } from '../screens/global-reports/globa-schedules-no-matches-report/GlobalSchedulesNoMatchesReportPage';
import { GlobalNoMatchesReportPage } from '../screens/global-reports/global-audios-no-matches-report/GlobalNoMatchesReportPage';
import { GlobalConsecutiveSchedulesReportPage } from '../screens/global-reports/global-consecutive-schedules-report/GlobalConsecutiveSchedulesReportPage';
import { MissingAudiosReportPage } from '../screens/global-reports/global-missing-audios-report/MissingAudiosReportPage';
import { LowerthirdPage } from '../screens/global-reports/lowerthird/screens/view/LowerthirdPage';
import { ReportsListPage } from '../screens/global-reports/reports-list/ReportsListPage';
import { ReportsViewPage } from '../screens/global-reports/reports-view/ReportsViewPage';
import { AuditMatchesPageAdapter } from '../screens/matches-list/AuditMatchesPageAdapter';
import { AuditScheduleStatusPageAdapter } from '../screens/schedule-status/AuditScheduleStatusPageAdapter';
import { AuditSchedulesListPageAdapter } from '../screens/schedules-list/AuditSchedulesListPageAdapter';
import { AuditSchedulesViewPageAdapter } from '../screens/schedules-view/AuditSchedulesViewPageAdapter';
import { AuditReportsPageAdapter } from '../screens/station-reports/AuditReportsPageAdapter';

export function AuditRoutes() {
  return (
    <Switch>
      <AppRoute path="/audit/s/:slug/matches" component={AuditMatchesPageAdapter} />
      <AppRoute path="/audit/s/:slug/schedule-status" component={AuditScheduleStatusPageAdapter} />
      <AppRoute path="/audit/s/:slug/audios" component={AuditAudiosPageAdapter} />
      <AppRoute path="/audit/s/:slug/upload" component={AuditUploadPageAdapter} />
      <AppRoute
        path="/audit/s/:slug/schedule/spot/:scheduleId"
        component={AuditSchedulesViewPageAdapter}
      />
      <AppRoute path="/audit/s/:slug/schedule" component={AuditSchedulesListPageAdapter} />
      <AppRoute path="/audit/s/:slug/reports/:reportType" component={AuditReportsPageAdapter} />

      {/* Redirects from deprecated /audit/s/:slug/reports paths */}
      <AppRoute
        path="/audit/s/:slug/reports"
        exact
        render={({ match, location }) => {
          const report = new URLSearchParams(location.search).get('report');
          const validReportTypes = ['equal-md5', 'no-matches', 'missing-audios', 'bcr-matches'];
          const targetReport = report && validReportTypes.includes(report) ? report : 'equal-md5';
          return <Redirect to={`/audit/s/${match.params.slug}/reports/${targetReport}`} />;
        }}
      />

      <AppRoute path="/audit/global-reports/gip-report" component={GipReportPreviewPage} />
      <AppRoute
        path="/audit/global-reports/gip-alternative-report"
        component={GipAlternativeReportPreviewPage}
      />
      <AppRoute path="/audit/global-reports/missing-media" component={MissingAudiosReportPage} />
      <AppRoute path="/audit/global-reports/no-matches" component={GlobalNoMatchesReportPage} />
      <AppRoute
        path="/audit/global-reports/schedules-no-matches"
        component={GlobalSchedulesNoMatchesReportPage}
      />
      {/* Redirects from deprecated /audit/global-reports/created paths */}
      <AppRoute
        path="/audit/global-reports/created/:reportId"
        render={({ match }) => <Redirect to={`/audit/saved-reports/${match.params.reportId}`} />}
      />
      <Redirect exact path="/audit/global-reports/created" to="/audit/saved-reports" />

      <AppRoute path="/audit/saved-reports/:id" component={ReportsViewPage} />
      <AppRoute path="/audit/saved-reports" exact component={ReportsListPage} />
      <AppRoute
        path="/audit/global-reports/consecutive-schedules"
        component={GlobalConsecutiveSchedulesReportPage}
      />
      <AppRoute path="/audit/global-reports/lowerthird" component={LowerthirdPage} />
      <AppRoute
        path="/audit/config/report-definitions/by-id/:id"
        component={ReportDefinitionEditorPage}
      />
      <AppRoute
        path="/audit/config/report-definitions/:reportType/default"
        component={ReportDefinitionDefaultEditorPage}
      />
      <AppRoute
        path="/audit/config/report-definitions/:reportType"
        component={ReportDefinitionListPage}
      />
      <AppRoute path="/audit/config" component={AuditConfigPage} />

      <AppRoute path="/audit/aod" component={AodRouter} />

      <Redirect exact path="/audit/global-reports" to="/audit/global-reports/gip-report" />
      <Redirect exact path="/audit/s/:slug" to="/audit/s/:slug/matches" />

      {/* catch all: redirect to most recent station or first station */}
      <DefaultStationRedirect to={(s) => `/audit/s/${s.slug}/matches`} />
    </Switch>
  );
}
